module.exports = __webpack_public_path__ + "d868385a6009520c5f9a16ee035d905b.svg";